import React from "react";
const AuctionPrice = () => {
    return (
        <>
        <div className="_nft_content_card_wrap _nft_content_price_wrap">
                                        <div className="_nft_content_card_inner _nft_auction_content_in">
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                    <div className="_nft_content_card_crypto_wrap">
                                                        <span className="_nft_content_card_crypto_ic">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                                fill="none" viewBox="0 0 20 20">
                                                                <path fill="#6B8CEF" fill-rule="evenodd"
                                                                    d="M9.844.842V7.69L4.778 9.955l5.066-2.263v5.945l-5.786-3.36L9.844.841Zm.002 0 5.787 9.434-5.787 3.361V7.692l5.066 2.263L9.846 7.69V.842Zm-.002 13.873v4.653l-5.79-8.013 5.79 3.36Zm.002 4.653v-4.654l5.787-3.36-5.787 8.014Z"
                                                                    clip-rule="evenodd" />
                                                            </svg>
                                                        </span>
                                                        <p className="_nft_content_card_crypto_txt">
                                                            3.52 ETH ($9118.1 USD)
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                    <button
                                                        className="_nft_content_card_crypto_btn d-inline-flex align-items-center justify-content-center w-100">
                                                        Place your bid
                                                        <span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30"
                                                                fill="none" viewBox="0 0 31 30">
                                                                <g clip-path="url(#a)">
                                                                    <path fill="#fff"
                                                                        d="M19 24.142v2.5H4v-2.5h15ZM19.733 0l9.722 9.723-1.767 1.77-1.325-.443-3.097 3.092 7.072 7.072-1.768 1.767-7.07-7.071-3.005 3.005.354 1.415-1.769 1.768-9.722-9.723 1.768-1.768 1.413.353 7.867-7.866-.441-1.325L19.733 0Z" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="a">
                                                                        <path fill="#fff" d="M0 0h30v30H0z"
                                                                            transform="translate(.47)" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>

                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        </>
    )
}
export default AuctionPrice;